export const cookieKeys = {
  sessionV1: '_ws_session_v1',
  // 社員番号ログイン時の組織IDを自動入力するために保存する
  // WebアプリからPWA起動時に組織IDを共有可能になる
  orgId: '__ws_org_id',
};

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  // name に正規表現のメタ文字が含まれる場合に備えてエスケープする
  const match = document.cookie.match(
    new RegExp(
      `(?:^|;\\s*)${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]+)`,
    ),
  );
  if (!match?.[1]) return undefined;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    // 不正なエンコードの場合はそのまま返す
    return match[1];
  }
}
